module.exports = __webpack_public_path__ + "static/media/flux-capacitor.787e32cb.svg";